import { render } from "./Mt_dtp4month.vue?vue&type=template&id=629e19d9&ts=true"
import script from "./Mt_dtp4month.vue?vue&type=script&lang=ts"
export * from "./Mt_dtp4month.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__